import { iIconProps } from '../icon';

export default function MailIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                fillRule='evenodd'
                d='M14.92 2.79c-1.95-.05-3.89-.05-5.84 0h-.06c-1.52.04-2.75.07-3.74.24-1.03.18-1.87.52-2.57 1.23S1.66 5.79 1.49 6.8c-.17.96-.19 2.16-.22 3.64v.06c-.02 1-.02 1.99 0 2.98v.06c.03 1.48.06 2.68.23 3.64.18 1.01.52 1.84 1.22 2.54.71.71 1.54 1.05 2.57 1.23.98.17 2.21.2 3.74.24h.06c1.95.05 3.89.05 5.84 0h.06c1.52-.04 2.75-.07 3.74-.24 1.03-.18 1.87-.52 2.57-1.23s1.05-1.53 1.22-2.54c.17-.96.19-2.16.22-3.64v-.06c.02-1 .02-1.99 0-2.98v-.06c-.03-1.48-.06-2.68-.23-3.64-.18-1.01-.52-1.84-1.22-2.54-.71-.71-1.54-1.05-2.57-1.23-.98-.17-2.21-.2-3.74-.24zM7.38 7.85a.76.76 0 0 0-1.03.26c-.21.36-.09.82.26 1.03l2.94 1.74c.87.51 1.62.86 2.44.86s1.57-.35 2.44-.86l2.94-1.74c.36-.21.47-.67.26-1.03a.75.75 0 0 0-1.03-.26l-2.94 1.74c-.84.5-1.29.66-1.68.66s-.83-.16-1.68-.66L7.36 7.85Z'
                fill='currentColor'
            />
        </svg>
    );
}
